import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
import styled from "styled-components";

import arrow from "../../../../assets/images/puchase-journey/select-arrow.svg";

export const inputColors = {
  linkColor: "#000000",
  defaultColor: "#ffffff",
  borderColor: "#979797",
  focusColor: "#ff5000",
};

type InputComponentProps = {
  $isPassword?: boolean;
};

export const InputContainer = styled(FormControl)`
  && {
    width: 100%;
  }
`;

export const InputComponent = styled(TextField)<InputComponentProps>`
  && {
    width: 100%;
    margin-bottom: 5px;

    background: ${inputColors.defaultColor};
    border-radius: 8px;
  }

  && .MuiOutlinedInput-root {
    border-radius: 8px;
    background-color: ${inputColors.defaultColor};
  }

  && .MuiOutlinedInput-notchedOutline {
    border-color: ${inputColors.borderColor};
  }

  && .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${inputColors.focusColor};
  }

  && .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${inputColors.focusColor};
  }

  && .MuiNativeSelect-icon {
    ${({ $isPassword }) =>
      !$isPassword &&
      `
        width: 18px;
        height: 18px;
        right: 16px;
        color: transparent;
        background-image: url(${arrow});
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      `}
  }

  && .MuiSvgIcon-root {
    ${({ $isPassword }) =>
      !$isPassword &&
      `
        color: transparent;
        background-image: url(${arrow});
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      `}
  }

  && input,
  && select {
    font-family: Figtree, sans-serif;
  }
`;

export const InputLabel = styled.label`
  && {
    display: block;
    margin-bottom: 8px;

    font-family: Figtree, sans-serif;
    font-weight: 300;
    font-size: 1rem;

    color: ${inputColors.linkColor};
  }
`;

export const InputLink = styled(Link)`
  && {
    font-family: Figtree, sans-serif;
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;

    text-align: right;
    color: ${inputColors.linkColor};
    text-decoration: none;
  }

  &&:hover {
    text-decoration: underline;
  }

  &&:focus-visible {
    outline: 2px solid ${inputColors.focusColor};
    outline-offset: 2px;
  }
`;
